import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getLiquidationHeat, type RiskSnapshot } from "../api/markets";

export function Intel() {
  const [heat, setHeat] = useState<RiskSnapshot[]>([]);
  useEffect(() => {
    getLiquidationHeat()
      .then(setHeat)
      .catch(() => setHeat([]));
  }, []);

  return (
    <div className="page">
      <h1>Intel — liquidation heat</h1>
      <p className="muted">
        Sorted by current liquidation pressure score. Informational only.
      </p>
      <div className="heat-grid">
        {heat.map((r) => (
          <Link to={`/trade/${r.symbol}`} key={r.symbol} className="heat-card">
            <div className="heat-symbol">{r.symbol}</div>
            <div className="heat-score">
              {r.liquidation_pressure.toFixed(0)}
              <span className="muted"> / 100</span>
            </div>
            <div className={`risk-confidence risk-confidence-${r.confidence}`}>
              {r.confidence}
            </div>
            <p>{r.explanation}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
